// ══════════════════════════════════════════════════════════════════
//  Acesso à aba "Clientes (Hub)" (/clientes)
// ══════════════════════════════════════════════════════════════════
//  Espelha useImplantacaoConsole: quem responde é a RPC
//  `cs.pode_ver_clientes_hub()` — owner, CS e Implantação. Cache por
//  USUÁRIO, não por workspace: a permissão não depende de qual workspace
//  está ativo.
//
//  Esconder a aba/o item de menu é conveniência. Quem barra de verdade são
//  as RPCs da área, que conferem a permissão de novo a cada chamada.
// ══════════════════════════════════════════════════════════════════

import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@hooks/useAuth';
import { podeVerClientesHub } from '@app/cs';

export const usePodeVerClientesHub = (): { enabled: boolean; loading: boolean } => {
  const { user } = useAuth();

  const query = useQuery({
    queryKey: ['podeVerClientesHub', user?.id || ''],
    queryFn: podeVerClientesHub,
    enabled: !!user?.id,
    staleTime: 10 * 60 * 1000,
    retry: false,
  });

  return { enabled: query.data === true, loading: query.isLoading };
};
